import { useSyncExternalStore } from 'react';
import { getBoundsSnapshot, getServerBoundsSnapshot, subscribeToBounds } from './boundsStore';
/**
 * Returns current window bounds and re-renders when the viewport resizes.
 * Uses useSyncExternalStore so React Compiler can track subscription updates.
 */ export const useBounds = ()=>{
    return useSyncExternalStore(subscribeToBounds, getBoundsSnapshot, getServerBoundsSnapshot);
};

//# sourceMappingURL=useBounds.js.map